import { FComposition, FCompositionType, QueryResolvers } from '@spazious/dollhouse-graphql';
import { decodeFCompositionId, FCompositionTypesEnum } from '@spazious/dollhouse-shallow-graph';
import { parseFCompositionSchemaId } from '@spazious/dollhouse-shared';

import { ApolloContext } from '../context.js';

/**
 * Resolver for the fcompositions query.
 */
export const fcompositions: QueryResolvers<ApolloContext>['fcompositions'] = async (
  _,
  variables,
  context
) => {
  const { api } = context;
  const { spaceId } = variables;

  const result = await api.diagramming.listDiagrammingDollhouseSchemas({
    filterActive: 'true',
    filterVirtualMeetingRoom: spaceId,
  });

  return result.data.data.reduce((acc, { id, attributes }) => {
    const nid = parseFCompositionSchemaId(attributes!.schemaType, parseInt(id.toString()));
    const type = variables.type ? FCompositionTypesEnum[`F${variables.type}`] : null;

    if (type !== null && decodeFCompositionId(nid).type !== type) {
      return acc;
    }

    return [
      ...acc,
      {
        id: attributes!.uuid!.toString(),
        nid,
        name: attributes!.schemaType,
        type: FCompositionType.Ensemble,
        schema: null!,
      },
    ];
  }, [] as FComposition[]);
};
